import exp from 'constants'
import { exportRequest } from './request'

// 查询指标统计列表
export function indicatorStatisticsQueryList() {
    return exportRequest({
        url: '/indicator/indicator/statistics/queryList',
        method: 'get'
    })
}

// 创建指标统计列表
export function indicatorStatisticsCreate(data) {
    return exportRequest({
        url: '/indicator/indicator/statistics/create',
        method: 'post',
        data
    })
}

// 修改指标统计报表
export function indicatorStatisticsUpdate(data) {
    return exportRequest({
        url: '/indicator/indicator/statistics/update',
        method: 'post',
        data
    })
}

// 删除指标统计表
export function indicatorStatisticsDel(data) {
    return exportRequest({
        url: '/indicator/indicator/statistics/delete',
        method: 'post',
        data
    })
}

// 查询指标维度
export function indicatorDimensionQuery(params) {
    return exportRequest({
        url: '/indicator/indicator/dimension/query',
        method: 'get',
        params
    })
}

// 创建指标维度
export function indicatorDimensionCreate(data) {
    return exportRequest({
        url: '/indicator/indicator/dimension/create',
        method: 'post',
        data
    })
}

// 查询单元格配置表
export function getCellSettingTable(params) {
    return exportRequest({
        url: '/indicator/cell/config/queryCellTable',
        method: 'get',
        params
    })
}
// 删除指标维度
export function indicatorDimensionDel(data) {
    return exportRequest({
        url: '/indicator/indicator/dimension/delete',
        method: 'post',
        data
    })
}

// 修改指标维度
export function indicatorDimensionUpdate(data) {
    return exportRequest({
        url: '/indicator/indicator/dimension/update',
        method: 'post',
        data
    })
}
// 查询单元格配置信息
export function getCellSettingInfo(params) {
    return exportRequest({
        url: '/indicator/cell/config/queryById',
        method: 'get',
        params
    })
}

// 查询问卷获取样本列表
export function areaDimensionQuerySurveyList(params) {
    return exportRequest({
        url: '/indicator/area/dimension/querySurveyList',
        method: 'get',
        params
    })
}

// 查询题目列表
export function areaDimensionQueryQuestionList(data) {
    return exportRequest({
        url: '/indicator/area/dimension/queryQuestionList',
        method: 'post',
        data
    })
}

// 创建地区维度
export function areaDimensionCreate(data) {
    return exportRequest({
        url: '/indicator/area/dimension/create',
        method: 'post',
        data
    })
}

// 获取地区维度列表
export function areaDimensionQueryAreaDimensionAndArea(params) {
    return exportRequest({
        url: '/indicator/area/dimension/queryAreaDimensionAndArea',
        method: 'get',
        params
    })
}

// 获取地区分类
export function areaDimensionQuery(params) {
    return exportRequest({
        url: '/indicator/area/dimension/query',
        method: 'get',
        params
    })
}

// 修改地区维度
export function areaDimensionUpdate(data) {
    return exportRequest({
        url: '/indicator/area/dimension/update',
        method: 'post',
        data
    })
}

// 查询答卷列表
export function areaDimensionQueryAnswerList(data) {
    return exportRequest({
        url: '/indicator/area/dimension/queryAnswerList',
        method: 'post',
        data
    })
}

// 查询时间维度列表
export function timeDimensionQuery(params) {
    return exportRequest({
        url: '/indicator/time/dimension/query',
        method: 'get',
        params
    })
}

// 创建时间表
export function timeDimensionCreate(data) {
    return exportRequest({
        url: '/indicator/time/dimension/create',
        method: 'post',
        data
    })
}

// 新增、编辑单元格设置
export function cellSubmit(data) {
    return exportRequest({
        url: '/indicator/cell/config/submit',
        method: 'post',
        data
    })
}
// 修改时间表
export function timeDimensionUpdate(data) {
    return exportRequest({
        url: '/indicator/time/dimension/update',
        method: 'post',
        data
    })
}

// 查询图标表格数据
export function dataQueryTable(data) {
    return exportRequest({
        url: '/indicator/data/queryTable',
        method: 'post',
        data
    })
}

// 导出图表
export function dataExport(data) {
  return exportRequest({
    url:'/indicator/data/export',
    method: 'post',
    data
  })
}

// 刷新图表数据
export function dataRefresh(data) {
    return exportRequest({
        url: '/indicator/data/refresh?indicatorStatisticsId=' + data.indicatorStatisticsId,
        method: 'post',
        data
    })
}

// 获取列批量设置数据
export function getColSettingInfo(params) {
    return exportRequest({
        url: '/indicator/cell/config/queryByCol',
        method: 'get',
        params
    })
}

// 获取图表数据刷新时间
export function dataRefreshDate(params) {
    return exportRequest({
        url: '/indicator/data/refresh/date',
        method: 'get',
        params
    })
}

// 获取行批量设置数据
export function getRowSettingInfo(params) {
    return exportRequest({
        url: '/indicator/cell/config/queryByRow',
        method: 'get',
        params
    })
}

// 获取图表刷新进度
export function dataRefreshProgress(params) {
    return exportRequest({
        url: '/indicator/data/refresh/progress',
        method: 'get',
        params
    })
}

// 列批量提交
export function colSubmitData(data) {
    return exportRequest({
        url: '/indicator/cell/config/submitByCol',
        method: 'post',
        data
    })
}

// 行批量提交数据
export function rowSubmitData(data) {
    return exportRequest({
        url: '/indicator/cell/config/submitByRow',
        method: 'post',
        data
    })
}

// 查询总览表数据
export function getOverViewTable(params) {
    return exportRequest({
        url: '/indicator/cell/config/queryByColCount',
        method: 'get',
        params
    })
}

// 查询树结构返回配置数量
export function cellConfigQueryByColCount(params) {
    return exportRequest({
        url: '/indicator/cell/config/queryByColCount',
        method: 'get',
        params
    })
}

// 查询是否配置完成，完成可预览和刷新
export function configQueryIsFinishAll(params) {
  return exportRequest({
    url: '/indicator/cell/config/queryIsFinishAll',
    method: 'get',
    params
  })
}

// 图表数据排序
export function dataQueryTableOrderClo(data) {
  return exportRequest({
    url: '/indicator/data/queryTableOrderClo',
    method: 'post',
    data
  })
}

// 查询维度是否配置完成，完成可配置单元格
export function configDimensionFinish(params) {
    return exportRequest({
      url: '/indicator/cell/config/queryDimensionFinishAll',
      method: 'get',
      params
    })
  }
// 查询指标统计详情
export function indicatorStatisticsQueryDetail(params) {
  return exportRequest({
    url: '/indicator/indicator/statistics/queryDetail',
    method: 'get',
    params
  })
}

//判断是否为指标创建者
export function indicatorStatisticsIsOwner(params) {
  return exportRequest({
    url: '/indicator/indicator/statistics/isOwner',
    method: 'get',
    params
  })
}

//计算编辑时单元格结果
export function calcCell(data) {
    return exportRequest({
        url: '/indicator/cell/config/calc',
        method: 'post',
        data
    })
}

//按列计算编辑时单元格结果
export function calcCol(data) {
    return exportRequest({
        url: '/indicator/cell/config/calcByCol',
        method: 'post',
        data
    })
}

//按行计算编辑时单元格结果
export function calcRow(data) {
    return exportRequest({
        url: '/indicator/cell/config/calcByRow',
        method: 'post',
        data
    })
}

// 计算查看时单元格结果
export function calcLook(id) {
    return exportRequest({
        url: `/indicator/cell/config/calcById?id=${id}`,
        method: 'post',
    })
}

// 查询单元格结果计算进度
export function getCalcProgress(params) {
    return exportRequest({
      url: '/indicator/cell/config/queryCalcProgress',
      method: 'get',
      params
    })
  }
  
// 查询单元格计算结果表格
export function getCalcResultTable(data) {
    return exportRequest({
        url: '/indicator/cell/config/queryCalcResultTable',
        method: 'post',
        data
    })
}